import React from 'react';
import LookupManager from './LookupManager';

const PowerComponent = () => {
    return (
        <LookupManager
            title="Power"
            endpoint="power"
            placeholder="Power value"
            loadingLabel="Loading power values..."
            emptyLabel="No power values yet."
        />
    );
};

export default PowerComponent;
